import { useMemo } from 'react';

import { useQuery } from '@apollo/client';
import ReferenceFlavorLexiconQuery, {
  ReferenceFlavorLexiconResponse,
} from '@graphql/queries/ReferenceFlavorLexiconQuery';

import { flavorKey, LexiconFlavor } from '../model/flavorTokens';

export const toLexicon = (
  nodes: ReferenceFlavorLexiconResponse['allReferenceFlavorNews']['nodes'],
): LexiconFlavor[] => {
  const byKey = new Map<string, LexiconFlavor>();
  nodes.forEach((n) => {
    const flavor = n.name ? flavorKey(n.name) : '';
    if (flavor && !n.deleted && !byKey.has(flavor))
      byKey.set(flavor, { flavor });
  });
  return Array.from(byKey.values());
};

/** The global reference flavor lexicon (~850 visible flavors), so a search can find any flavor. */
const useReferenceFlavorLexicon = () => {
  const { data, loading, error } = useQuery<ReferenceFlavorLexiconResponse>(
    ReferenceFlavorLexiconQuery,
  );
  const lexicon = useMemo(
    () => toLexicon(data?.allReferenceFlavorNews.nodes ?? []),
    [data],
  );
  return { lexicon, loading, error };
};

export default useReferenceFlavorLexicon;
